import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

import FloodAlertIcon from './FloodAlertIcon.js';

function FloodAlertGroupSummaryComponent({ floodAreas, showIconOnNull, noOutputIfNoAreas = false }) {

	let nullIcon = <FloodAlertIcon severityLevel={4} style={{width: "80%", maxWidth: "125px"}} />;
	if(!showIconOnNull) {
		nullIcon = null;
	}

	if(!floodAreas || !floodAreas.length) {
		if(noOutputIfNoAreas) {
			return null;
		}
		return <Row className="justify-content-center align-items-center d-flex">
			<Col xs={12} lg={12}>{nullIcon}</Col>
			<Col xs={12} lg={12}><i>No flood warnings</i></Col>
		</Row>;
	}

	let counts = {
		0: 0,
		1: 0,
		2: 0,
		3: 0,
		4: 0
	}

	if(floodAreas && floodAreas.length) {
		for(let area of floodAreas) {
			if(area.severityLevel) {
				++counts[area.severityLevel];
			} else {
				++counts[0];
			}
		}
	}

	let hasAlert = false;
	if(counts[1] || counts[2] || counts[3]) {
		hasAlert = true;
	}

	return <Row>
		<Col xs={12}>
			{hasAlert && <Alert variant="warning">
				<Row>
					<Col xs={12}><b>Flood Warnings in Effect</b></Col>
				</Row>
				<Row className="justify-content-center">
					{counts[1] > 0 && <Col xs={4}><FloodAlertIcon severityLevel={1} style={{width: "80%", maxWidth: "125px"}} /> <b><i>x{counts[1]}</i></b></Col>}
					{counts[2] > 0 && <Col xs={4}><FloodAlertIcon severityLevel={2} style={{width: "80%", maxWidth: "125px"}} /> <b><i>x{counts[2]}</i></b></Col>}
					{counts[3] > 0 && <Col xs={4}><FloodAlertIcon severityLevel={3} style={{width: "80%", maxWidth: "125px"}} /> <b><i>x{counts[3]}</i></b></Col>}
				</Row>
			</Alert>}
			{!hasAlert && <Row className="justify-content-center d-flex">
				<Col xs={12} lg={12}>{nullIcon}</Col>
				<Col xs={12} lg={12}><i>No flood warnings</i></Col>
			</Row>}
		</Col>
	</Row>;
}


export default FloodAlertGroupSummaryComponent;